import { useEffect } from "react";
import { SPINNING_WHEEL_TYPE } from "@cede/types";
import { useSpinningWheelEligibility } from "./useSpinningWheelEligibility";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { useSpinningWheelDialogStore } from "@/store/spinningWheelDialogStore";

/**
 * Auto-opens the spinning wheel dialog for eligible users on TMA.
 */
export const useSpinningWheelDialog = () => {
  const { isTMA } = useTelegramContext();
  const { handleOpen: handleOpenSpinningWheelDialog } = useSpinningWheelDialogStore();

  const { isEligible, isLoading: eligibilityLoading } = useSpinningWheelEligibility({
    spinningWheelType: SPINNING_WHEEL_TYPE.TMA_ONBOARDING,
  });

  useEffect(() => {
    if (!isTMA) return;
    if (eligibilityLoading) return;
    if (!isEligible) return;
    handleOpenSpinningWheelDialog();
  }, [isTMA, isEligible, eligibilityLoading, handleOpenSpinningWheelDialog]);
};
